import { aboutButtons, aboutMariaText } from "i18n/about";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const MainAbout = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = aboutMariaText[lang];
  const btn = aboutButtons[lang];

  const navigate = useNavigate();

  return (
    <section className="bg-[#f5f5f3] py-16 md:py-24">
      <div className="max-w-4xl mx-auto text-[#111] px-6">
        {/* Title */}
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-4xl font-[Crimson] uppercase tracking-wide text-reddark font-semibold">
            {t.title}
          </h2>
        </div>

        {/* Intro */}
        <div className="space-y-8 text-base md:text-lg leading-relaxed">
          {t.intro.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </div>

      {/* Highlight */}
      <div className="my-20 max-w-6xl mx-auto border border-black/80 px-8 md:px-16 py-12 md:py-16 text-center text-reddark">
        <p className="text-lg md:text-2xl font-light font-[Crimson]">
          {t.highlight}
        </p>
      </div>

      {/* Body */}
      <div className="max-w-4xl mx-auto text-[#111] px-6">
        <div className="space-y-8 text-base md:text-lg leading-relaxed">
          {t.body.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </div>

      <div className="my-20 max-w-6xl mx-auto border border-black/80 px-8 md:px-16 py-12 md:py-16 text-center text-reddark space-y-8">
        <p className="text-lg md:text-2xl font-light font-[Crimson]">
          {t.closingTitle}
        </p>

        <p className="text-lg md:text-2xl font-light font-[Crimson]">
          {t.closingText}
        </p>

        <p className="text-lg md:text-2xl font-light font-[Crimson]">{t.cta}</p>
      </div>
    </section>
  );
};

export default MainAbout;
